import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleWelcomeHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/people/welcome` URL. Flag off it renders the embedded
 * Ember host, whose `people.welcome` route replaces itself with the Profiles
 * list; flag on it forwards to the migrated list URL directly.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the
 * `journeys` segment, so the resolver's bundle-aware branch can rebuild the
 * target from the bundle prefix when the `/workspaces/last` sentinel needs
 * resolving.
 */
function JourneysPeopleWelcomeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleWelcomeHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/welcome')({
  component: JourneysPeopleWelcomeRoute,
});
